module.exports = __webpack_public_path__ + "img/HA2514-198.8fe3f049.jpg";